import * as React from 'react';
import Confetti from 'react-confetti';

import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

const classroomActivitiesSrc = `${window.postbuildEnv.CDN_URL}/images/pages/dashboard/illustrations-classroom-activities-2.svg`

const exploreDemoLink = `${window.postbuildEnv.DEFAULT_URL}/teachers/view_demo`

const WelcomeModal = ({ close, size }) => {
  const { width, height } = size;

  const { modalRef } = useModalAccessibility(close);

  return (
    <div className="modal-container welcome-modal-container">
      <div className="modal-background" />
      <Confetti
        height={height}
        numberOfPieces={700}
        recycle={false}
        width={width}
      />
      <div
        aria-labelledby='title'
        aria-modal="true"
        className="welcome-modal quill-modal"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="modal-body">
          <div className="welcome-modal-image-box">
            <div className="text">
              <h1 id="title">Welcome to Quill!</h1>
              <p>Our mission as a non-profit is to help students become strong writers, so all our content is completely free to use with an unlimited number of students.</p>
            </div>
            <img alt="Teacher at projector in classroom" src={classroomActivitiesSrc} />
          </div>

          <div className="welcome-modal-option-boxes">
            <div className="welcome-modal-option-box">
              <h2>Try a Demo</h2>
              <p>Play around with a fully loaded demo to see sample student data and reports.</p>
              <a className="quill-button-archived contained primary medium focus-on-light" href={exploreDemoLink}>Start exploring</a>
            </div>

            <div className="welcome-modal-option-box">
              <h2>Start Setting Up</h2>
              <p>Ready to set up your own classes? Jump right into your account.</p>
              <button className="quill-button-archived outlined secondary medium focus-on-light" onClick={close} type="button">Let&#39;s go!</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default WelcomeModal
